// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"559333fb","8902":"559333fb"}[chunkId] + ".chunk.css";
};